import { TableFooter } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

function descendingComparator(a, b, orderBy) {
  if (a[orderBy] === null && b[orderBy] !== null) {
    return 1;
  }
  if (a[orderBy] !== null && b[orderBy] === null) {
    return -1;
  }
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort, headCells } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  //const {t} = useTranslation();

  /*
  const headCells = [
    { id: 'startTime', numeric: false, disablePadding: true, label: t('transportList.started') },
    { id: 'endTime', numeric: false, disablePadding: false, label: t('transportList.ended') },
    { id: 'description', numeric: false, disablePadding: false, label: t('transportList.description') },
    { id: 'serialNumber', numeric: false, disablePadding: false, label: t('transportList.serial') },
    { id: 'deviceName', numeric: false, disablePadding: false, label: t('transportList.name') },
    { id: 'alerts', numeric: false, disablePadding: false, label: t('transportList.alerts') },
  ]; */

  return (
    <TableHead>
      <TableRow>
        {headCells
          ? headCells.map((headCell) => (
              <TableCell
                key={headCell.id}
                align={headCell.numeric ? "right" : "left"}
                padding={headCell.disablePadding ? "none" : "default"}
                sortDirection={orderBy === headCell.id ? order : false}
              >
                <TableSortLabel
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : "asc"}
                  onClick={createSortHandler(headCell.id)}
                >
                  {headCell.label}
                </TableSortLabel>
              </TableCell>
            ))
          : undefined}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  headCells: PropTypes.array.isRequired,
};

const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
}));

function EnhancedTableRow({ data }) {
  var arr = [];
  var x = 0;
  for (const [key, value] of Object.entries(data.row)) {
    if (key !== "id") {
      arr.push(<TableCell key={x}>{value}</TableCell>);
    }
    x = x + 1;
  }
  return (
    <TableRow
      hover
      onClick={() => data.handleRowClick(data.row.id)}
      style={
        data.getRowStyle ? data.getRowStyle(data.row) : { cursor: "pointer" }
      }
    >
      {arr}
    </TableRow>
  );
}

export default function SortableTable({ data }) {
  //Parameters required

  //Table data

  //Table head column names and types
  /*
	data.headCells = [
    { id: 'startTime', numeric: false, disablePadding: true, label: t('transportList.started') },
    { id: 'endTime', numeric: false, disablePadding: false, label: t('transportList.ended') },
    { id: 'description', numeric: false, disablePadding: false, label: t('transportList.description') },
    { id: 'serialNumber', numeric: false, disablePadding: false, label: t('transportList.serial') },
    { id: 'deviceName', numeric: false, disablePadding: false, label: t('transportList.name') },
    { id: 'alerts', numeric: false, disablePadding: false, label: t('transportList.alerts') },
  ];
  */

  //Table body column names

  //Default sort row

  //Row style (optional)

  //Handle table row click

  const classes = useStyles();
  const [tableData, setTableData] = useState();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(data.rowsPerPage || 10);
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState(data.defaultSortRow);
  const { t } = useTranslation();

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    if (data) {
      setTableData(data.tableData);
    }
  }, [data]);

  return (
    <React.Fragment>
      <TableContainer>
        <Table size="medium">
          <EnhancedTableHead
            classes={classes}
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            rowCount={tableData ? tableData.length : 0}
            headCells={data.headCells}
            //
          />
          <TableBody>
            {tableData
              ? stableSort(tableData, getComparator(order, orderBy))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => (
                    <EnhancedTableRow
                      key={index}
                      data={{
                        row: row,
                        handleRowClick: data.handleRowClick,
                        getRowStyle: data.getRowStyle,
                      }}
                    />
                  ))
              : undefined}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TableCell>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={tableData ? tableData.length : 0}
                  rowsPerPage={rowsPerPage}
                  labelRowsPerPage={t("sortableTable.rowsPerPage")}
                  labelDisplayedRows={({ from, to, count }) => {
                    return `${from}-${to} / ${count}`;
                  }}
                  page={page}
                  onChangePage={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                />
              </TableCell>
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    </React.Fragment>
  );
}
